import styled from 'styled-components';

export const Content = styled.div`
  text-align: left;

  .input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .label {
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%;
      color: var(--color-text-muted);
      padding: 0 10px 0 0;
    }

    .input,
    .form-select,
    .textarea {
      margin: 0 0 20px;
    }
  }

  .public {
    display: flex;

    .label {
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%;
      color: var(--color-text-muted);
      padding: 0 10px 0 0;
    }
  }

  .buttonGroup {
    display: flex;
    gap: 10px;
    justify-content: flex-start;
    margin-top: 20px;

    button {
      width: 130px;
    }
  }
`;
